module.exports = __webpack_public_path__ + "static/Maharashtra-logo-fda8b87112504272f20f7aba669411ac.png";